<template>
  <div></div>
</template>

<script>
if (window.localStorage.getItem("redirect_wx")) {
  // alert(window.localStorage.getItem("redirect_wx") +
  //   window.location.search.substr());
  window.$sk.goto(
    window.localStorage.getItem("redirect_wx") + window.location.search.substr()
  );
}
export default {
  name: "short",
};
</script>
